<div class="complaint-request-description" [innerText]="submitComplaintText"></div>

<media-file-upload-box
	[allowed_extensions]="allowedExtensions"
	[allowed_number]="5"
	[allowed_max_size]="allowedMaxFileSize"
	[params]="params"
	[triggerOrderStatus]=false
	[reset_after]="2000">
</media-file-upload-box>

<div class="complaint-text-area">
	<h3>
		<i class="fal fa-message-exclamation fa-fw"></i>
		{{'Complaint reason' | translate}}
	</h3>
	<mat-form-field appearance="fill">
	  	<textarea 
			matInput 
			[formControl]="userInput" 
			placeholder="{{ 'Please provide details' | translate }}"
			cdkTextareaAutosize
			#autosize="cdkTextareaAutosize"
			cdkAutosizeMinRows="18"
			cdkAutosizeMaxRows="18">
		</textarea>  
	  	<!-- Show validation message if the input is invalid -->
		@if(userInput.invalid && (userInput.dirty || userInput.touched)){
			<mat-error>
				{{'This field is required' | translate}} 
			</mat-error>
		}
	</mat-form-field>
</div>

<mat-dialog-actions class="buttons">
	<button mat-raised-button color="primary" [disabled]="userInput.invalid" (click)="onSubmit()">
		{{data.yes | translate}}
	</button>
	<button mat-raised-button [mat-dialog-close]="'no'">
		{{data.no | translate}}
	</button>
<mat-dialog-actions>
